<template>
	<div class="popup" @click="close">
		<div class="box">
			<div class="flex-c mt50 mb50 ">
				<img src="@/assets/images/success.png" show-menu-by-longpress alt="">
				<span class="f36 color-333 fb ml10">报名成功</span>
			</div>
			<div class="flex-c flex-dc f26 color-A mb200">
				<span>添加班主任微信，获得更多贴心服务</span>
				<img class="img-box" :src="qrCodeData" alt="">
				<span>长按二维码识别，或保存截图</span>
			</div>
			<div class="icon">
				<span class="iconfont icon-shanchujiaobiao"></span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props:{
			qrCodeData:{}
		},
		data() {
			return {

			}
		},
		created() {
		},
		methods: {
			close() {
				this.$emit('openPopup', 1)
			}
		}
	}
</script>

<style lang="less" scoped>
	.popup {
		position: fixed;
		background: #000000ad;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;

		

		.box {
			width: 550px;
			height: 660px;
			background: #FFFFFF;
			border-radius: 22px;
			position: relative;
			.icon {
				width: 50px;
				height: 60px;
				position: absolute;
				top: 20px;
				right: 20px;
				color: #fff;
			}
		}

		.img-box {
			width: 290px;
			height: 290px;
			margin: 36px 0 26px 0;
		}

	}
</style>
